import MicroModal from 'micromodal'

export const HandleShowCloseModal = (toShow, toClose) => {
  
    MicroModal.init()

    MicroModal.show(toShow)
    MicroModal.close(toClose)
}

